import GigsSupport from "../../../views/GigsSupport";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const GigsSupportRoutes = [
  {
    menuName: MenuNames.GIGS_SUPPORT,
    path: "/gigs-support",
    component: GigsSupport,
    exact: true,
  },
];

export default GigsSupportRoutes;
